import moment from "moment";
import { sortVersionsByStartDate } from "../../pricing.mapper";

const checkGaps = (versionsList: any[], newVersion): [boolean, string | null] => {
  const newVersionIdx = versionsList.findIndex(ver => ver.id === newVersion.id);
  const nextVersion =
    newVersionIdx !== versionsList.length - 1 ? versionsList[newVersionIdx + 1] : null;
  const previousVersion = newVersionIdx !== 0 ? versionsList[newVersionIdx - 1] : null;
  const isGapNext =
    nextVersion !== null && newVersion?.endDate
      ? moment(nextVersion.startDate).diff(moment(newVersion.endDate), 'days') > 1
      : false;
  const isGapPrev =
    previousVersion !== null && previousVersion?.endDate
      ? moment(newVersion.startDate).diff(moment(previousVersion.endDate), 'days') > 1
      : false;
  if (isGapPrev && isGapNext) {
    return [true, 'BOTH'];
  } else if (isGapNext) {
    return [true, 'FUTURE'];
  } else if (isGapPrev) {
    return [true, 'PAST'];
  } else {
    return [false, null];
  }
};

const checkOverlaps = (versionsList: any[], newVersion) => {
  const newVersionIdx = versionsList.findIndex(ver => ver.id === newVersion.id);
  const nextVersion =
    newVersionIdx !== versionsList.length - 1 ? versionsList[newVersionIdx + 1] : null;
  const previousVersion = newVersionIdx !== 0 ? versionsList[newVersionIdx - 1] : null;

  const isOverlapNext =
    nextVersion && newVersion?.endDate
      ? moment(nextVersion.startDate).isSameOrBefore(newVersion.endDate, 'days')
      // if newVersion.endDate is null, then if nextVersion.startDate is sameOrBefore newVersion startDate, theres overlap.
      // if nextVersion is null, then no overlap.
      : nextVersion
        ? moment(nextVersion.startDate).isSameOrAfter(newVersion.startDate, 'days')
        : false


  const isOverlapPrev =
    (previousVersion && previousVersion?.endDate === null) ||
      previousVersion?.endDate === undefined
      ? true
      : previousVersion
        ? moment(previousVersion.endDate).isSameOrAfter(moment(newVersion.startDate), 'days')
        : false;

  if (isOverlapPrev && isOverlapNext) {
    return [true, 'BOTH'];
  } else if (isOverlapNext) {
    return [true, 'FUTURE'];
  } else if (isOverlapPrev) {
    return [true, 'PAST'];
  } else {
    return [false, null];
  }
};

export const checkGapOverlapVersions = (newVersion, versionsList) => {
  const updatedVersionsList = versionsList.map(ver => {
    if (ver.id === newVersion.id) {
      return newVersion;
    } else return ver;
  });
  const sortedByStartDateVersions = sortVersionsByStartDate(updatedVersionsList);
  const isGap = checkGaps(sortedByStartDateVersions, newVersion);
  const isOverlap = checkOverlaps(sortedByStartDateVersions, newVersion);
  return [isGap, isOverlap];
};

export const checkGapOverlapVersionsDelete = (deletedVersion, versionsList) => {
  const updatedVersionsList = versionsList.filter(vers => vers.id !== deletedVersion.id);

  const sortedByStartDateVersions = sortVersionsByStartDate(updatedVersionsList);
  const isGap = checkGapsDelete(sortedByStartDateVersions);
  const isOverlap = checkOverlapsDelete(sortedByStartDateVersions);
  return [isGap, isOverlap];
}

const checkGapsDelete = (list) => {
  let gaps: [boolean, string | null] = [false, null]
  for (let i = 0; i < list.length - 1; i++) {
    const prevVersion = i > 0 ? list[i - 1] : null;
    const nextVersion = i < list.length - 1 ? list[i + 1] : null;
    const currentVersion = list[i];

    const isGapNext =
      nextVersion !== null && currentVersion?.endDate
        ? moment(nextVersion.startDate).diff(moment(currentVersion.endDate), 'days') > 1
        : false;
    const isGapPrev =
      prevVersion !== null && prevVersion?.endDate
        ? moment(currentVersion.startDate).diff(moment(prevVersion.endDate), 'days') > 1
        : false;

    if (isGapPrev || isGapNext) {
      gaps = [true, 'BOTH']
    }
  }
  return gaps;
}

const checkOverlapsDelete = (list) => {
  let overlaps: [boolean, string | null] = [false, null]
  for (let i = 0; i < list.length - 1; i++) {
    const prevVersion = i > 0 ? list[i - 1] : null;
    const nextVersion = i < list.length - 1 ? list[i + 1] : null;
    const currentVersion = list[i];

    const isOverlapNext =
      nextVersion && currentVersion?.endDate
        ? moment(nextVersion.startDate).isSameOrBefore(currentVersion.endDate, 'days')
        // if newVersion.endDate is null, then if nextVersion.startDate is sameOrBefore newVersion startDate, theres overlap.
        // if nextVersion is null, then no overlap.
        : nextVersion
          ? moment(nextVersion.startDate).isSameOrAfter(currentVersion.startDate, 'days')
          : false


    const isOverlapPrev =
      (prevVersion && prevVersion?.endDate === null) ||
        prevVersion?.endDate === undefined
        ? true
        : prevVersion
          ? moment(prevVersion.endDate).isSameOrAfter(moment(currentVersion.startDate), 'days')
          : false;

    if (isOverlapPrev || isOverlapNext) {
      overlaps = [true, 'BOTH']
    }
  }
  return overlaps;
}